"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewer = viewer;
exports.default = void 0;

var _CompletionModal = require("components/CompletionModal");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _Listener = babelHelpers.interopRequireDefault(require("components/Notifications/Listener"));

var _class, _descriptor, _temp;

var DiscussionViewer = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(DiscussionViewer, _Component);

  function DiscussionViewer() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DiscussionViewer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DiscussionViewer)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DiscussionViewer, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_CompletionModal.CompletionBody, {
        course: this.item.details.course,
        passed: this.item.details.passed,
        rewards: this.item.details.rewards,
        nextItem: this.item.details.nextCatalogItem
      });
    }
  }]);
  return DiscussionViewer;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = DiscussionViewer;

function viewer(notificationList, selectedItem, item) {
  (0, _CompletionModal.show)(item.details.passed, item.details.course, item.details.rewards, item.details.nextCatalogItem);

  _Listener.default.markSeen([item.id]);

  _Listener.default.markRead([item.id]);
}